import React from 'react';
import { useUser } from '@lore/auth';
import { useConnect } from '@lore/query-connect';
import ParentLayout from '../Layout';
import Navigation from '../../../dialogs_common/Navigation';
import Urls from '../Urls';
import Form from './Form';
import { PayloadStates } from '@lore/utils';
import useRouter from '../../../hooks/useRouter';

export default function Layout(props) {
  const { history, match } = useRouter();
  const user = useUser();
  const event = useConnect('event.byId', {
    id: Number(match.params.eventId)
  });

  if (event.state === PayloadStates.FETCHING) {
    return null;
  }

  return (
    <ParentLayout
      event={event}
      page="Student Count"
      title="How many students will participate in or be impacted by this event?"
      // description={(
      //   <>
      //     <span className="font-semibold italic">TIP</span>: Some Partners are passionate about working
      //     with students who have certain life experiences. This is another way to find the best match
      //     for your students.
      //   </>
      // )}
    >
      <Form
        user={user}
        event={event}
        navigation={(
          <Navigation v5={true} activeStep={2} steps={13}/>
        )}
        onPrevious={(newData) => history.push(Urls(event).PARTICIPANTS)}
        onNext={(newData) => history.push(Urls(event).STUDENT_AGE)}
        onSkip={() => history.push(Urls(event).STUDENT_AGE)}
        onExit={() => history.push(Urls(event).EVENT_EDIT)}
      />
    </ParentLayout>
  );
};
